<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1CFcLtg/tc-custom/9781614237440.jpg?1705317487582" alt="This image is the cover for the book Civil War Ghosts of Southwest Missouri, Haunted America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Civil War Ghosts of Southwest Missouri, Haunted America
      </h1>
      <p class="bookDescription body article font2">
        <p>For southwest Missouri, the Civil War was an unparalleled period of violence, sorrow and anger. As the torches burned the physical landscape, the depredations inflicted were also scorched upon the psyche of the people who lived through fires. Survey Carthage's battlefield for stubborn holdouts or hold vigil at the Kendrick House for innocent bystanders who were swept up into the stratagems of bushwhackers and guerrillas. Meet the Bloody Spikes, Rotten Johnny Reb and scores more figures from the region's past who continue to trouble its present.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lisa Livingston-Martin
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Haunted America
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ce9c076e